<template>
  <div class="relative shrink-0">
    <button
      type="button"
      class="bg-background-neutral-secondary flex flex-col rounded-[20px] px-3 py-3"
      @click="emit('onClick')"
    >
      <p
        class="text-text-neutral-primary flex items-center gap-1 text-start text-sm font-medium"
      >
        <template v-if="isMultiTrip && routeParts.arr">
          <span class="truncate">{{ routeParts.dep }}</span>
          <RouteIcon class="text-text-neutral-primary h-4 w-4 shrink-0" />
          <span class="truncate">{{ routeParts.arr }}</span>
        </template>
        <span v-else>{{ routeText }}</span>
      </p>
      <div class="mt-0.5 flex items-center gap-2">
        <span
          class="text-text-neutral-tertiary flex items-center gap-1 text-xs"
        >
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" class="shrink-0"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.66667 2.5C7.1269 2.5 7.5 2.8731 7.5 3.33333V4.16667H12.5V3.33333C12.5 2.8731 12.8731 2.5 13.3333 2.5C13.7936 2.5 14.1667 2.8731 14.1667 3.33333V4.18928C14.239 4.19327 14.3089 4.19797 14.3765 4.2035C14.8449 4.24177 15.2755 4.3239 15.68 4.52998C16.3072 4.84956 16.8171 5.35949 17.1367 5.9867C17.3428 6.39115 17.4249 6.82173 17.4632 7.29015C17.5 7.74114 17.5 8.29476 17.5 8.96556V12.7011C17.5 13.3719 17.5 13.9255 17.4632 14.3765C17.4249 14.8449 17.3428 15.2755 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C15.2755 17.3428 14.8449 17.4249 14.3765 17.4632C13.9255 17.5 13.3719 17.5 12.7011 17.5H7.2989C6.6281 17.5 6.07447 17.5 5.62348 17.4632C5.15507 17.4249 4.72448 17.3428 4.32003 17.1367C3.69283 16.8171 3.18289 16.3072 2.86331 15.68C2.65724 15.2755 2.5751 14.8449 2.53683 14.3765C2.49998 13.9255 2.49999 13.3719 2.5 12.7011V8.96557C2.49999 8.29477 2.49998 7.74114 2.53683 7.29015C2.5751 6.82173 2.65724 6.39115 2.86331 5.9867C3.18289 5.35949 3.69283 4.84956 4.32003 4.52998C4.72448 4.3239 5.15507 4.24177 5.62348 4.2035C5.69111 4.19797 5.76104 4.19327 5.83333 4.18928V3.33333C5.83333 2.8731 6.20643 2.5 6.66667 2.5ZM5.7592 5.86463C5.39385 5.89448 5.20702 5.94858 5.07668 6.01499C4.76308 6.17478 4.50811 6.42975 4.34832 6.74335C4.28192 6.87368 4.22781 7.06052 4.19796 7.42587C4.19598 7.45011 4.19412 7.47481 4.19239 7.5H15.8076C15.8059 7.47481 15.804 7.45011 15.802 7.42587C15.7722 7.06052 15.7181 6.87368 15.6517 6.74335C15.4919 6.42975 15.2369 6.17478 14.9233 6.01499C14.793 5.94858 14.6061 5.89448 14.2408 5.86463C13.8657 5.83398 13.3805 5.83333 12.6667 5.83333H7.33333C6.61952 5.83333 6.13427 5.83398 5.7592 5.86463ZM4.16667 12.6667V9.16667H15.8333V12.6667C15.8333 13.3805 15.8327 13.8657 15.802 14.2408C15.7722 14.6061 15.7181 14.793 15.6517 14.9233C15.4919 15.2369 15.2369 15.4919 14.9233 15.6517C14.793 15.7181 14.6061 15.7722 14.2408 15.802C13.8657 15.8327 13.3805 15.8333 12.6667 15.8333H7.33333C6.61952 15.8333 6.13427 15.8327 5.7592 15.802C5.39385 15.7722 5.20702 15.7181 5.07668 15.6517C4.76308 15.4919 4.50811 15.2369 4.34832 14.9233C4.28192 14.793 4.22781 14.6061 4.19796 14.2408C4.16732 13.8657 4.16667 13.3805 4.16667 12.6667Z" fill="currentColor"/></svg>
          {{ datesText }}
        </span>
        <span
          class="text-text-neutral-tertiary flex items-center gap-1 text-xs"
        >
          <PersonIcon class="text-text-neutral-tertiary h-4 w-4 shrink-0" />
          {{ passengersCount }}
        </span>
      </div>
    </button>
    <button
      type="button"
      class="bg-button-secondary-default absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full"
      :aria-label="$t('recentSearches.removeAria')"
      @click.stop="emit('onDelete')"
    >
      <!-- prettier-ignore -->
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0 text-text-neutral-primary"><path d="M3.17 3.17a.58.58 0 0 1 .82 0L6 5.18l2.01-2.01a.58.58 0 1 1 .82.82L6.82 6l2.01 2.01a.58.58 0 1 1-.82.82L6 6.82 3.99 8.83a.58.58 0 1 1-.82-.82L5.18 6 3.17 3.99a.58.58 0 0 1 0-.82Z" fill="currentColor"/></svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { RecentSearch } from '@/entities/recent-searches';

  import PersonIcon from '@/assets/images/person-icon.svg?component';
  import RouteIcon from '@/assets/images/multi-trip/route-icon-16x16.svg?component';

  import { useRecentSearchCard } from '../model/use-recent-search-card';

  const props = defineProps<{
    search: RecentSearch;
    index: number;
  }>();

  const emit = defineEmits<{
    onClick: [];
    onDelete: [];
  }>();

  const { isMultiTrip, routeText, routeParts, datesText, passengersCount } =
    useRecentSearchCard(() => props.search);
</script>
